import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { GlobalInfraComponent } from './global-infra/global-infra.component';
import { OrgInfraComponent } from './org-infra/org-infra.component';
import { OrgNameStepComponent } from './steps-new-org/org-name-step/org-name-step.component';
import { OrgConfirmStepComponent } from './steps-new-org/org-confirm-step/org-confirm-step.component';
import { ShowWarningComponent } from './show-warning/show-warning.component';
import { OrgUrlsStepComponent } from './steps-new-org/org-urls-step/org-urls-step.component';
import { OrgTableUsersStepComponent } from './steps-new-org/org-table-users-step/org-table-users-step.component';
import { GlobalUserAdminComponent } from './global-user-admin/global-user-admin.component';
import { GlobalTableUsersStepComponent } from './global-user-admin/global-user-admin-table-step/global-user-admin-table-step.component';
import { GlobalUserAdminConfirmStepComponent } from './global-user-admin/global-user-admin-confirm-step/global-user-admin-confirm-step.component';
import { DocumentationUrlComponent } from './documentation-url/documentation-url.component';
import { ContainerLogsComponent } from './container-logs/container-logs.component';
import { OrgAcrStepComponent } from './steps-new-org/org-acr-step/org-acr-step.component';

@NgModule({
    declarations: [
        SidebarComponent,
        NavbarComponent,
        FooterComponent,
        GlobalInfraComponent,
        OrgInfraComponent,
        OrgNameStepComponent,
        OrgConfirmStepComponent,
        ShowWarningComponent,
        OrgUrlsStepComponent,
        OrgTableUsersStepComponent,
        GlobalUserAdminComponent,
        GlobalTableUsersStepComponent,
        GlobalUserAdminConfirmStepComponent,
        DocumentationUrlComponent,
        ContainerLogsComponent,
        OrgAcrStepComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        TranslateModule.forChild(),
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        SidebarComponent,
        NavbarComponent,
        FooterComponent,
        GlobalInfraComponent,
        OrgInfraComponent,
        OrgTableUsersStepComponent,
        OrgNameStepComponent,
        OrgConfirmStepComponent,
        ShowWarningComponent,
        OrgUrlsStepComponent,
        GlobalUserAdminComponent,
        GlobalUserAdminConfirmStepComponent,
        DocumentationUrlComponent,
        ContainerLogsComponent,
        OrgAcrStepComponent
    ],
    entryComponents: [
    ]
})
export class ComponentsModule { }
